// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeaselinkBanner_wrapper__33_cF","desktopImage":"LeaselinkBanner_desktopImage__yQnPM","mobileImage":"LeaselinkBanner_mobileImage__2re97"};